import { Component, inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { Navigation } from '@sbd-account-portal/app/core/navigation/navigation.types';
import { NavigationService } from '@sbd-account-portal/app/core/navigation/navigation.service';
import { environment } from '@sbd-account-portal/app/environments/environment';
import { CIPXDrawerManagerService } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { QuoteRequestIntakeFormDrawerWrapperComponent } from '@sbd-account-portal/app/modules/quote/request/quote-request-intake-form-drawer-wrapper.component';

@Component({
    selector     : 'modern-layout',
    templateUrl  : './modern.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ModernLayoutComponent implements OnInit, OnDestroy
{

    private _drawerManagerService = inject(CIPXDrawerManagerService);

    isScreenSmall: boolean;
    navigation: Navigation;
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    isDarkMode: boolean = false;
    readonly headerLogo = {
        light: {
            src: '/assets/images/surety-square/sbd-bold-powered-by-surety-square-dark-350x41.png',
            srcset:
                '/assets/images/surety-square/sbd-bold-powered-by-surety-square-dark-350x41.png 1x, /assets/images/surety-square/sbd-powered-by-surety-square-692x82.png 2x',
        },
        dark: {
            src: '/assets/images/surety-square/sbd-bold-powered-by-surety-square-light-350x41.png',
            srcset:
                '/assets/images/surety-square/sbd-bold-powered-by-surety-square-light-350x41.png 1x, /assets/images/surety-square/sbd-powered-by-surety-square-light-692x82.png 2x',
        },
    };

    homeUrl = `/dashboard`;

    /**
     * Constructor
     */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _navigationService: NavigationService,
        private _fuseMediaWatcherService: FuseMediaWatcherService,
        private _fuseNavigationService: FuseNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for current year
     */
    get currentYear(): number
    {
        return new Date().getFullYear();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

        // Subscribe to navigation data
        this._navigationService.navigation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((navigation: Navigation) => {
                this.navigation = navigation;
            });

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) => {

                // Check if the screen is small
                this.isScreenSmall = !matchingAliases.includes('md');
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle navigation
     *
     * @param name
     */
    toggleNavigation(name: string): void
    {
        // Get the navigation
        const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

        if ( navigation )
        {
            // Toggle the opened status
            navigation.toggle();
        }
    }

    requestQuote(): void {
      this._drawerManagerService.openDrawer(QuoteRequestIntakeFormDrawerWrapperComponent, {
        data: {
          // to do things like:
          // stateAbbreviation: 'WA'
        }
      });
    }
}
